// extracted by mini-css-extract-plugin
export var contentBody = "_c5-9";
export var headerImage = "_c5-2";
export var imageButton = "_c5-7";
export var imageButtonIcon = "_c5-8";
export var imageHeader = "_c5-4";
export var imageHeaderText = "_c5-5";
export var imageOverlay = "_c5-3";
export var imageTitle = "_c5-6";
export var imageWrapper = "_c5-1";
export var taskList = "_c5-a";
export var widget = "_c5-0";